<div class="sticky-div">
	<app-users-filter></app-users-filter>
</div>
<div class="content">
	<table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.id}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="first_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.first_name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="last_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.last_name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.email}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="enabled">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Enabled</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.enabled}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="user_type">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.user_type}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="id_organization">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Org Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.id_organization}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="organization_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Org Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.organization_name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="signature">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Signature</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.signature}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="appointment_description">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Appt Description</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.appointment_description}}</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)">
		</tr>

	</table>

</div>
